import React, { useEffect } from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { Table, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Messages'
import Loader from '../components/Loader'
import Paginate from '../components/Paginate'
import { useTranslation } from 'react-i18next';

import { variant_main } from '../constants/generalConstants'
import {
  listGroups,
  deleteGroup,
  createGroup,
} from '../actions/groupActions'
import { GROUP_CREATE_RESET } from '../constants/groupConstants'

const GroupListScreen = ({ history, match }) => {
  const pageNumber = match.params.pageNumber || 1

  const dispatch = useDispatch()

  const groupList = useSelector((state) => state.groupList)
  const { loading, error, groups, page, pages } = groupList //

  const groupDelete = useSelector((state) => state.groupDelete)
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = groupDelete

  const groupCreate = useSelector((state) => state.groupCreate)
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    group: createdgroup,
  } = groupCreate

  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    dispatch({ type: GROUP_CREATE_RESET })

    if (!userInfo || !userInfo.isAdmin) {
      history.push('/login')
    }

    if (successCreate) {
      history.push(`/admin/cats/${createdgroup._id}/edit`)
    } else {
      dispatch(listGroups('', pageNumber)) //
    }
  }, [
    dispatch,
    history,
    userInfo,
    successDelete,
    successCreate,
    createdgroup,
    pageNumber,
  ])

  const deleteHandler = (id) => {
    if (window.confirm('Are you sure')) {
      dispatch(deleteGroup(id))
    }
  }

  const createGroupHandler = () => {
    dispatch(createGroup())
  }

  const { t } = useTranslation();

  return (
    <>
      <Row className='align-items-center'>
        <Col>
          <h1>{t('Groups')}</h1>
        </Col>
        <Col className='text-right'>
          <Button className='my-3' onClick={createGroupHandler} variant={variant_main}>
            <i className='fas fa-plus-circle'></i> {t('Create group')}
          </Button>
        </Col>
      </Row>
      {loadingDelete && <Loader />}
      {errorDelete && <Message variant='danger'>{errorDelete}</Message>}
      {loadingCreate && <Loader />}
      {errorCreate && <Message variant='danger'>{errorCreate}</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className='table-sm'>
            <thead>
              <tr>
                <th>{t('ID')}</th>
                <th>{t('NAME')}</th>
                <th>{t('ORDER')}</th>
                <th>{t('DESCRIPTION')}</th>
                <th>{t('KEYWORDS')}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {groups.map((group) => (
                <tr key={group._id}>
                  <td>{group._id}</td>
                  <td>{group.cat_name}</td>
                  <td>{group.cat_order}</td>
                  <td>{group.cat_description}</td>
                  <td>{group.cat_keywords}</td>
                  <td>
                    <LinkContainer to={`/admin/cats/${group._id}/edit`}>
                      <Button variant='light' className='btn-sm'>
                        <i className='fas fa-edit'></i>
                      </Button>
                    </LinkContainer>
                    <Button
                      variant='danger'
                      className='btn-sm'
                      onClick={() => deleteHandler(group._id)}
                    >
                      <i className='fas fa-trash'></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Paginate pages={pages} page={page} isAdmin={true} />
        </>
      )}
    </>
  )
}

export default GroupListScreen
